import React from 'react'

import { AppAlertIcon } from 'components/Common/AppSvgIcons/AppAlertIcon'
import {
  AppFieldWrapper,
  AppErrorWrapper,
  AppFieldParentWrapper,
  AppPrefixDividerWrapper,
  AppPrefixWrapper,
  AppErrorMessageWrapper,
  AppLabelWrapper,
  AppNumericWrapper,
} from '../AppCommonStyles/AppFormField.style'
import appColors from 'appColors'

interface IconProps {
  color?: string
}

export interface IAppNumericFieldProps {
  mask?: string
  value?: string | number
  error?: string
  label?: string
  disabled?: boolean
  placeholder?: string
  prefix?: string
  size: 'lg' | 'md' | 'sm'
  type: 'numeric'
  onChange?: (value) => void
  Icon?: React.ComponentType<IconProps>
  onBlur?: (value) => void
  name?: string
}

export const AppNumericField: React.FC<IAppNumericFieldProps> = ({
  size,
  mask,
  Icon,
  value,
  label,
  disabled,
  onChange,
  onBlur,
  error = '',
  placeholder,
  type = 'text',
  prefix,
  name,
}) => {
  return (
    <div className="w-full">
      {label && <AppLabelWrapper>{label}</AppLabelWrapper>}
      <AppFieldParentWrapper>
        <AppFieldWrapper prefix={prefix} size={size} error={!!error} disabled={!!disabled}>
          {Icon && <Icon />}
          {prefix && (
            <>
              <AppPrefixWrapper size={size}>{prefix}</AppPrefixWrapper>
              <AppPrefixDividerWrapper size={size}>
                <div className="self-stretch bg-app-grey-40 relative w-px" />
              </AppPrefixDividerWrapper>
            </>
          )}

          <AppNumericWrapper
            value={value}
            disabled={disabled}
            onChange={(event) => {
              //remove commas from the value
              const value = event.target.value
              if (typeof value === 'string') {
                onChange?.((value as string).replace(/,/g, ''))
              } else {
                onChange?.(value)
              }
            }}
            onBlur={onBlur}
            prefix={prefix}
            thousandSeparator=","
            decimalSeparator="."
            allowNegative={true}
            placeholder={placeholder || 'Placeholder'}
            data-testid={name}
            error={error}
          />
        </AppFieldWrapper>
        {error && <AppErrorMessage error={error} />}
      </AppFieldParentWrapper>
    </div>
  )
}

export const AppErrorMessage = ({ error }) => {
  return (
    <AppErrorWrapper>
      <AppAlertIcon color={appColors['app-red']['70']} />
      <AppErrorMessageWrapper>{error}</AppErrorMessageWrapper>
    </AppErrorWrapper>
  )
}
